import { render, staticRenderFns } from "./OrderData.vue?vue&type=template&id=54141b9e&"
import script from "./OrderData.vue?vue&type=script&lang=js&"
export * from "./OrderData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports